// extracted by mini-css-extract-plugin
export default {"auftragsnummer":"BescheidModal_auftragsnummer__A2HUp","grey":"BescheidModal_grey__xpQle"};